<template>
    <common-modal @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="large">
            <div class="appointment-length-modal__header">
                <common-icon name="white-warning" size="large"></common-icon>
                <div class="appointment-length-modal__heading">
                    <p>{{ $t('forms.auth.schedule.modals.appointment_length.heading_1') }}</p>
                    <p>{{ $t('forms.auth.schedule.modals.appointment_length.heading_2') }}</p>
                    <p class="appointment-length-modal__heading--bold">
                        {{ $t('forms.auth.schedule.modals.appointment_length.heading_3') }}
                    </p>
                </div>
            </div>
            <div class="appointment-length-modal__content">
                <p>{{ $t('forms.auth.schedule.modals.appointment_length.content_1') }}</p>
                <p>{{ $t('forms.auth.schedule.modals.appointment_length.content_2') }}</p>
            </div>
            <div class="appointment-length-modal__footer">
                {{
                    $t('forms.auth.schedule.modals.appointment_length.footer', {
                        appointmentLength: scheduleInfo.appointmentLength,
                        locationName: scheduleInfo.name,
                    })
                }}
            </div>
            <common-buttons>
                <common-button
                    :label="$t('common.microcopy.cancel')"
                    type="secondary"
                    size="large"
                    @click="emitEvent({ name: 'close' })"
                ></common-button>
                <common-button
                    :label="$t('forms.auth.schedule.microcopy.apply_change')"
                    type="primary"
                    size="large"
                    @click="emitEvent({ name: 'apply-time-change' })"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    export default {
        props: {
            scheduleInfo: { type: Object, required: true },
        },
    }
</script>
